export const PREVIEW_PAGE_ID = 'dev-preview'
